var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"text-inherit hover:text-primary",attrs:{"to":_vm.url},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_vm._v(_vm._s(_vm.params.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }